var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    x: 0,
    y: 0,
    viewBox: "3 3 42 42",
    xmlSpace: "preserve",
    width: 60,
    height: 60
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 24c0 11.044-8.956 20-20 20S4 35.044 4 24 12.956 4 24 4s20 8.956 20 20z",
    fill: "#4caf50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4v20l8 4-8.843 16H24c11.053 0 20-8.947 20-20S35.053 4 24 4z",
    fill: "#ffc107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24c0 11.044-8.956 20-20 20S4 35.044 4 24 12.956 4 24 4s20 8.956 20 20z",
    fill: "#4caf50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4v20l8 4-8.843 16H24c11.053 0 20-8.947 20-20S35.053 4 24 4z",
    fill: "#ffc107"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.84 15H24v13l-3-1L7.16 13.26h-.02C10.68 7.69 16.91 4 24 4c7.8 0 14.55 4.48 17.84 11z",
    fill: "#f44336"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.158 13.264l8.843 14.862L21 27 7.158 13.264z",
    fill: "#dd2c00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.157 44l8.934-16.059L28 25l-4.843 19z",
    fill: "#558b2f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.865 15H24l-1.579 4.58L41.865 15z",
    fill: "#f9a825"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24c0 4.969-4.031 9-9 9s-9-4.031-9-9 4.031-9 9-9 9 4.031 9 9z",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24c0 3.867-3.133 7-7 7s-7-3.133-7-7 3.133-7 7-7 7 3.133 7 7z",
    fill: "#2196f3"
  })));
}
export default SvgChrome;